// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "Agenda-module--backgroundContainmentImage--20753";
export var backgroundImage = "Agenda-module--backgroundImage--6311c";
export var colored = "Agenda-module--colored--5ecf4";
export var content = "Agenda-module--content--cb0a3";
export var ctaBtn = "Agenda-module--ctaBtn--93759";
export var ctaWrapper = "Agenda-module--ctaWrapper--f7e2f";
export var table = "Agenda-module--table--f50f7";
export var wrapper = "Agenda-module--wrapper--92489";